/*
 * Warna etalase pilihan pemilik di atas design system "Ramoo". Logika murni, bisa diuji tanpa DOM.
 *
 * Pemilik memilih satu warna utama; halaman tamu memakainya sebagai `--accent` (styles.css). Yang
 * diputuskan di sini hanya warna TEKS di atasnya, supaya tombol tetap terbaca kalau warnanya terang.
 */

const HEX = /^#[0-9a-f]{6}$/i

/** Hanya hex 6 digit yang dipakai. Nilai lain akan membuat `--accent` tidak sah dan tombol lenyap. */
export const warnaSah = (warna: string | null | undefined): warna is string =>
  !!warna && HEX.test(warna)

/** Luminans relatif WCAG 2.x dari hex 6 digit. */
const luminans = (hex: string): number => {
  const [r = 0, g = 0, b = 0] = [1, 3, 5].map((awal) => {
    const v = Number.parseInt(hex.slice(awal, awal + 2), 16) / 255
    return v <= 0.04045 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4
  })
  return 0.2126 * r + 0.7152 * g + 0.0722 * b
}

/** Kontras WCAG warna ini terhadap putih. */
export const kontrasPutih = (hex: string): number => 1.05 / (luminans(hex) + 0.05)

/**
 * Teks di atas warna ini: terang atau gelap?
 *
 * Aturannya sama dengan yang dijaga server saat pemilik menyimpan warna utama (`WarnaUtama` di
 * `@ramoo/contracts`): kontras minimal 4,5:1 terhadap teks putih. Warna yang lolos aturan itu
 * tetap berteks terang, seperti sebelumnya. Teks gelap hanya untuk warna yang terlalu terang,
 * yaitu data lama dari sebelum aturan itu ada.
 */
export const teksDiAtas = (hex: string): "terang" | "gelap" =>
  kontrasPutih(hex) >= 4.5 ? "terang" : "gelap"
